// src/codebase/components/Badge.jsx
//
// Kept local (per .claude/skills/frontend-component/SKILL.md point 3): its
// tone-based API — a continuous score bucket or an ad-hoc priority/risk
// string, not a fixed named status — doesn't map onto shared/ui/StatusBadge's
// discrete `map` API. Restyled onto Tailwind design tokens instead of
// codebase.css's `.badge`/tone classes, matching statusMaps.js's own
// plain-Tailwind convention, so it reads consistently with the rest of a
// modernized page.
//
// `dot` mirrors shared/ui/StatusBadge.jsx's `pulse` prop (bg-current, so one
// class works across every tone instead of a second color map) — borrowed
// from golive/components/Cards/ServiceCard.jsx's confidence-pill look for
// severity/priority/risk chips.

import PropTypes from "prop-types";

const TONE_CLASSES = {
  red: "bg-red-100 text-red-700",
  orange: "bg-orange-100 text-orange-700",
  yellow: "bg-amber-100 text-amber-700",
  green: "bg-green-100 text-green-700",
  blue: "bg-blue-100 text-blue-700",
  muted: "bg-gray-100 text-gray-500",
};

export default function Badge({ tone = "muted", dot = false, children }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold ${
        TONE_CLASSES[tone] ?? TONE_CLASSES.muted
      }`}
    >
      {dot && <span className="inline-block w-1.5 h-1.5 rounded-full bg-current shrink-0" />}
      {children}
    </span>
  );
}

Badge.propTypes = {
  tone: PropTypes.oneOf(["red", "orange", "yellow", "green", "blue", "muted"]),
  dot: PropTypes.bool,
  children: PropTypes.node,
};
